import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';

export class PackGroup extends Model<Schemas['packGroups'], Models> {}
